import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { IWalkthroughNavigator } from '@ups/xplat/base/in-app-help';

/** Web navigation for a tour: the Angular router, directly. */
@Injectable({ providedIn: 'root' })
export class WebWalkthroughNavigatorService implements IWalkthroughNavigator {
  constructor(private readonly router: Router) {}

  currentRoute(): string {
    return this.router.url;
  }

  async navigate(route: string): Promise<void> {
    await this.router.navigateByUrl(route);
  }
}
